import { Picture } from "./Picture";

// Renders admin-editable SEO content blocks (heading + body + optional image).
// Per-section layout: "auto" (alternating sides), "image-right", "image-left",
// or "full-width". Falls back to alternating sides when no layout is set.
export default function ContentSections({ sections }) {
  const list = (sections || []).filter((s) => (s.heading || "").trim() || (s.body || "").trim());
  if (!list.length) return null;
  return (
    <div className="container-cz pb-16 space-y-12" data-testid="content-sections">
      {list.map((s, i) => {
        const layout = s.layout || "auto";
        const hasImg = !!s.image;
        const Text = (
          <>
            {s.heading && <h2 className="font-display text-2xl sm:text-3xl font-bold text-slate-900 mb-3">{s.heading}</h2>}
            {s.body && <div className="text-slate-600 leading-relaxed whitespace-pre-line">{s.body}</div>}
          </>
        );

        // Full-width (or no image): single column, optional banner image below.
        if (layout === "full-width" || !hasImg) {
          return (
            <section key={i} data-testid={`content-section-${i}`} data-layout={layout} className={layout === "full-width" ? "" : "max-w-3xl"}>
              <div className={layout === "full-width" ? "max-w-3xl" : ""}>{Text}</div>
              {hasImg && (
                <div className="rounded-2xl overflow-hidden aspect-[21/9] mt-6 shadow-cz bg-slate-100">
                  <Picture src={s.image} alt={s.image_alt || s.heading || ""} loading="lazy" className="w-full h-full object-cover" />
                </div>
              )}
            </section>
          );
        }

        // Two-column with image on a chosen side (auto = alternate by index).
        const imageLeft = layout === "image-left" || (layout === "auto" && i % 2 === 1);
        return (
          <section key={i} data-testid={`content-section-${i}`} data-layout={layout} className="grid gap-8 items-center lg:grid-cols-2">
            <div className={imageLeft ? "lg:order-2" : ""}>{Text}</div>
            <div className={`rounded-2xl overflow-hidden aspect-[4/3] shadow-cz bg-slate-100 ${imageLeft ? "lg:order-1" : ""}`}>
              <Picture src={s.image} alt={s.image_alt || s.heading || ""} loading="lazy" className="w-full h-full object-cover" />
            </div>
          </section>
        );
      })}
    </div>
  );
}
